const block = document.querySelector('section.hero');

if(block) {
  const heroTitle = document.querySelector('.hero-title');
  const spans = heroTitle.querySelectorAll('span');
  const spanCount = spans.length;
  if(spanCount > 1) {
    const percentageVisible = (1 / spanCount) * 100;

    // Create a style element for keyframes
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeInOut {
        0% { opacity: 0; }
        ${percentageVisible * 0.15}% { opacity: 1; }
        ${percentageVisible * 0.70}% { opacity: 1; }
        ${percentageVisible * 0.95}% { opacity: 0; }
        100% { opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }
}